import { cn } from '@/utils/cn'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Spinner({ size = 'md', className }: SpinnerProps) {
  const sizeClass = { sm: 'w-3.5 h-3.5', md: 'w-5 h-5', lg: 'w-8 h-8' }[size]
  return (
    <div className={cn(sizeClass, 'border-2 border-claro-200 border-t-claro-600 rounded-full animate-spin', className)} />
  )
}
